<script lang="ts" setup>
import type { FieldData } from '~~/server/api/forms/form'

export interface PagesDocumentsSearchEmits {
    (e: 'update', value: string): void
}

const route = useRoute()
const { $t } = useNuxtApp()

const formKitDateData = ref<FieldData>({
    name: 'date_from',
    type: 'date',
    label: $t('Vyberte dátum'),
    defaultValue: route.query.date_from,
})
const emit = defineEmits<PagesDocumentsSearchEmits>()
</script>
<template>
  <aside class="bg-gray-1 p-2 rounded-1 mb-6">
    <div
      class="d-md-flex fs-smaller fs-md-normal align-items-center ps-md-2 fw-bold"
    >
      <div class="d-flex align-items-center flex-grow-1">
        <svg
          class="d-block flex-shrink-0 me-3"
          width="14"
          height="14"
          aria-hidden="true"
        >
          <use xlink:href="#sort" />
        </svg>
        <span :id="`documents-date-filter-label-${formKitDateData.name}`">
          {{ $t('Zobraziť dokumenty aktuálne v deň podpísania zmluvy') }}
        </span>
      </div>
      <div class="flex-shrink-0 mt-2 mt-md-0">
        <FormKitCustomDate
          :data="formKitDateData"
          @update="(value: string) => emit('update', value)"
        />
      </div>
    </div>
  </aside>
</template>
